(() => {
  if (window.__perfumiarzJudgeMePdpPatched) return;
  window.__perfumiarzJudgeMePdpPatched = true;

  const WIDGET_SELECTOR =
    '#judgeme_product_reviews.jdgm-widget.jdgm-review-widget, [data-perfumiarz-store-reviews-widget]';
  const REVIEWS_PER_PAGE = 3;
  const SORT_OPTIONS = ['created_at', 'highest_rating', 'lowest_rating'];
  const MODAL_ID = 'judgeme-pdp-write-review-modal';
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const stateByWidget = new WeakMap();
  let isUpdating = false;
  let rafId = null;

  const isStoreReviewsWidget = (widget) =>
    Boolean(widget?.hasAttribute('data-perfumiarz-store-reviews-widget'));

  const getI18n = () => {
    const source = window.PerfumiarzJudgeMeI18n || window.PerfumiarzAirReviewsI18n || {};

    return {
      kickerText: source.kickerText || 'Other Noses about the Ingredient',
      writeReview: source.writeReview || 'Write your review',
      ctaLead: source.ctaLead || 'Have you tried this ingredient?',
      paginationPrevious: source.paginationPrevious || 'Previous reviews',
      paginationNext: source.paginationNext || 'Next reviews',
      paginationLabel: source.paginationLabel || 'Review pages',
      paginationPage: source.paginationPage || 'Page __number__',
      reviewerFallback: source.reviewerFallback || 'Reviewer',
      sortLabel: source.sortLabel || 'Sort by:',
      sortRecent: source.sortRecent || 'Newest',
      sortHighest: source.sortHighest || 'Highest Rating',
      sortLowest: source.sortLowest || 'Lowest Rating',
      reviewCountLabel: source.reviewCountLabel || 'Based on {{ count }} reviews',
      noReviewsText:
        source.noReviewsText ||
        window.jdgmSettings?.widget_no_review_text ||
        'Be the first to write a review',
      modalTitle:
        source.modalTitle ||
        window.jdgmSettings?.widget_open_form_text ||
        'Write a review',
      modalClose: source.modalClose || 'Close',
      modalReviewTitleLabel:
        source.modalReviewTitleLabel ||
        window.jdgmSettings?.widget_review_title_field_text ||
        'Review title',
      modalReviewTitlePlaceholder:
        source.modalReviewTitlePlaceholder ||
        window.jdgmSettings?.widget_review_title_placeholder_text ||
        'Give your review a title',
      modalRatingLabel:
        source.modalRatingLabel ||
        window.jdgmSettings?.widget_rating_field_text ||
        'Rating',
      modalBodyLabel:
        source.modalBodyLabel ||
        window.jdgmSettings?.widget_review_body_field_text ||
        'Review content',
      modalBodyPlaceholder:
        source.modalBodyPlaceholder ||
        window.jdgmSettings?.widget_review_body_placeholder_text ||
        'Start writing here...',
      modalDisplayNameLabel:
        source.modalDisplayNameLabel ||
        'Display name (displayed publicly as {{ public_name }})',
      modalDisplayNamePlaceholder:
        source.modalDisplayNamePlaceholder ||
        window.jdgmSettings?.widget_name_placeholder_text ||
        'Display name',
      modalEmailLabel:
        source.modalEmailLabel ||
        window.jdgmSettings?.widget_email_field_text ||
        'Email address',
      modalEmailPlaceholder:
        source.modalEmailPlaceholder ||
        window.jdgmSettings?.widget_email_placeholder_text ||
        'Your email address',
      modalSubmitLead: source.modalSubmitLead || 'I want to share my opinion',
      modalSubmitAction:
        source.modalSubmitAction ||
        window.jdgmSettings?.widget_submit_review_text ||
        'Submit review',
      modalSubmittingAction: source.modalSubmittingAction || 'Submitting review...',
      modalRequiredRating:
        source.modalRequiredRating ||
        window.jdgmSettings?.widget_required_field_error_text ||
        'This field is required.',
      modalInvalidEmail:
        source.modalInvalidEmail ||
        window.jdgmSettings?.widget_email_field_error_text ||
        'Please enter a valid email address.',
      modalSubmitError:
        source.modalSubmitError || 'Something went wrong. Please try again.',
      modalGdpr:
        source.modalGdpr || window.jdgmSettings?.widget_gdpr_statement || '',
    };
  };

  const getProductTitle = (widget) => {
    const storeTitle = widget?.dataset?.perfumiarzTitle?.trim();
    if (storeTitle) return storeTitle;

    const fromWidget = widget?.dataset?.productTitle?.trim();
    if (fromWidget) return fromWidget;

    const titleNode = document.querySelector(
      'product-info .product__title h1, .product__title h1, h1.product__title'
    );

    return titleNode ? titleNode.textContent.trim() : '';
  };

  const getProductId = (widget) => {
    const value = widget?.dataset?.productId || widget?.dataset?.id || '';
    return String(value || '').trim();
  };

  const getShopDomain = () => {
    if (window.jdgm?.SHOP_DOMAIN) return window.jdgm.SHOP_DOMAIN;
    if (window.Shopify?.shop) return window.Shopify.shop;
    return window.location.hostname;
  };

  const ensureKicker = (widget) => {
    const section = widget.closest('.shopify-section');
    if (!section) return;

    section.classList.add('judgeme-pdp-section');

    let kicker = section.querySelector('.judgeme-pdp-kicker');
    if (!kicker) {
      kicker = document.createElement('p');
      kicker.className = 'judgeme-pdp-kicker';
      section.insertBefore(kicker, section.firstChild);
    }

    kicker.textContent = getI18n().kickerText;
  };

  const createElement = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof text === 'string') node.textContent = text;
    return node;
  };

  const getBoxHeight = (root, selector) => {
    const node = root?.querySelector(selector);
    if (!node) return 0;
    return Math.ceil(node.getBoundingClientRect().height);
  };

  const syncStageHeight = (root, state, config, fallbackHeight = 0) => {
    const stage = root?.querySelector(config.stageSelector);
    if (!stage || !state) return;

    const contentHeight = getBoxHeight(root, config.contentSelector);
    const nextHeight = Math.max(Number(state[config.stateKey]) || 0, fallbackHeight, contentHeight);

    if (nextHeight > 0) {
      state[config.stateKey] = nextHeight;
      stage.style.minHeight = `${nextHeight}px`;
    }
  };

  const animateStageTransition = (root, previousContent, direction, state, config, fallbackHeight = 0) => {
    const stage = root?.querySelector(config.stageSelector);
    const viewport = stage?.querySelector('.judgeme-pdp-stage__viewport');
    const nextContent = viewport?.querySelector(config.contentSelector);

    if (!stage || !viewport || !nextContent || !previousContent) {
      syncStageHeight(root, state, config, fallbackHeight);
      return;
    }

    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      syncStageHeight(root, state, config, fallbackHeight);
      return;
    }

    const outgoingLayer = createElement(
      'div',
      'judgeme-pdp-stage__layer judgeme-pdp-stage__layer--outgoing'
    );
    const incomingLayer = createElement(
      'div',
      'judgeme-pdp-stage__layer judgeme-pdp-stage__layer--incoming'
    );

    outgoingLayer.appendChild(previousContent);
    incomingLayer.appendChild(nextContent);
    viewport.replaceChildren(outgoingLayer, incomingLayer);

    const nextHeight = Math.ceil(nextContent.getBoundingClientRect().height);
    const stageHeight = Math.max(Number(state[config.stateKey]) || 0, fallbackHeight, nextHeight);

    if (stageHeight > 0) {
      state[config.stateKey] = stageHeight;
      stage.style.minHeight = `${stageHeight}px`;
      viewport.style.minHeight = `${stageHeight}px`;
    }

    if (config.stageClass) {
      stage.classList.add(config.stageClass);
    }
    stage.classList.add('is-animating', direction === 'prev' ? 'is-prev' : 'is-next');

    let incomingStarted = false;
    const startIncoming = () => {
      if (incomingStarted) return;
      incomingStarted = true;
      stage.classList.add('is-entering');
    };

    requestAnimationFrame(() => {
      stage.classList.add('is-active');

      outgoingLayer.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'opacity') startIncoming();
      });
      window.setTimeout(startIncoming, 120);
    });

    let cleanedUp = false;
    const cleanup = () => {
      if (cleanedUp) return;
      cleanedUp = true;

      stage.classList.remove('is-animating', 'is-prev', 'is-next', 'is-active', 'is-entering');
      if (config.stageClass) {
        stage.classList.remove(config.stageClass);
      }
      viewport.style.minHeight = '';
      viewport.replaceChildren(nextContent);
      syncStageHeight(root, state, config, fallbackHeight);
    };

    incomingLayer.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'transform') cleanup();
    });
    window.setTimeout(cleanup, 380);
  };

  const getSortLabels = () => {
    const settings = window.jdgmSettings || {};
    const i18n = getI18n();

    return {
      created_at: i18n.sortRecent || settings.widget_sorting_most_recent_text || 'Newest',
      highest_rating:
        i18n.sortHighest ||
        settings.widget_sorting_highest_rating_text ||
        'Highest Rating',
      lowest_rating:
        i18n.sortLowest ||
        settings.widget_sorting_lowest_rating_text ||
        'Lowest Rating',
    };
  };

  const getReviewCountLabel = (count) => {
    const template =
      getI18n().reviewCountLabel ||
      window.jdgmSettings?.badge_n_reviews_text ||
      'Based on {{ count }} reviews';

    return String(template).replace(/\{\{\s*(count|n)\s*\}\}/g, String(count));
  };

  const formatReviewDate = (value) => {
    const normalized = normalizeString(value);
    if (!normalized) return null;

    const parseable = normalized.replace(
      /^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2}(?:\.\d+)?)\s+UTC$/i,
      '$1T$2Z'
    );
    const date = new Date(parseable);
    if (Number.isNaN(date.getTime())) return null;

    const locale = document.documentElement.lang || window.Shopify?.locale || undefined;

    try {
      return {
        label: new Intl.DateTimeFormat(locale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          timeZone: 'UTC',
        }).format(date),
        dateTime: date.toISOString().slice(0, 10),
      };
    } catch (error) {
      return {
        label: normalized,
        dateTime: normalized,
      };
    }
  };

  const normalizeString = (value) => String(value == null ? '' : value).trim();

  const getReviewerName = (review, index) => {
    const i18n = getI18n();
    const name =
      normalizeString(review?.reviewer_name) ||
      normalizeString(review?.reviewer) ||
      normalizeString(review?.author);

    if (name) return name;
    return `${i18n.reviewerFallback} ${index + 1}`;
  };

  const getReviewBody = (review) => {
    const body = normalizeString(review?.body || review?.content || review?.review);
    if (body) return body;

    const bodyHtml = normalizeString(review?.body_html || '');
    if (!bodyHtml) return '';

    const temp = document.createElement('div');
    temp.innerHTML = bodyHtml;
    return normalizeString(temp.textContent || '');
  };

  const getReviewTitle = (review) => normalizeString(review?.title || review?.review_title);

  const clampRating = (rating) => {
    const number = Number(rating);
    if (!Number.isFinite(number)) return 0;
    return Math.max(0, Math.min(5, Math.round(number)));
  };

  const createRatingDots = (rating) => {
    const safeRating = clampRating(rating);
    const dots = createElement('div', 'judgeme-pdp-rating-dots');
    dots.setAttribute('aria-label', `${safeRating} / 5`);

    for (let index = 0; index < 5; index += 1) {
      const dot = createElement('span', 'judgeme-pdp-rating-dot');
      if (index < safeRating) {
        dot.classList.add('is-filled');
      }
      dots.appendChild(dot);
    }

    return dots;
  };

  const escapeHtml = (value) =>
    String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  const fillTemplate = (template, token, value) =>
    String(template || '').replace(new RegExp(`\\{\\{\\s*${token}\\s*\\}\\}`, 'g'), value);

  const stripHtml = (value) => {
    const temp = document.createElement('div');
    temp.innerHTML = String(value || '');
    return normalizeString(temp.textContent || '');
  };

  const decodeHtmlString = (value) => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  };

  const getSubmitSuccessHtml = () => {
    const settings = window.jdgmSettings || {};
    return (
      (settings.autopublish && settings.widget_submit_success_msg_with_auto_publish) ||
      settings.widget_submit_success_msg_no_auto_publish ||
      ''
    );
  };

  const setModalOpenState = (isOpen) => {
    document.documentElement.classList.toggle('judgeme-pdp-modal-open', isOpen);
    document.body.classList.toggle('judgeme-pdp-modal-open', isOpen);
  };

  const closeWriteReviewModal = () => {
    const root = document.getElementById(MODAL_ID);
    if (!root) return;
    if (typeof root.__onEscape === 'function') {
      document.removeEventListener('keydown', root.__onEscape);
    }
    if (typeof root.__onVisualViewportChange === 'function') {
      window.visualViewport?.removeEventListener('resize', root.__onVisualViewportChange);
      window.visualViewport?.removeEventListener('scroll', root.__onVisualViewportChange);
      window.removeEventListener('resize', root.__onVisualViewportChange);
    }
    if (root.__focusVisibilityTimeout) {
      window.clearTimeout(root.__focusVisibilityTimeout);
    }
    if (root.__focusVisibilityFrame) {
      window.cancelAnimationFrame(root.__focusVisibilityFrame);
    }
    root.remove();
    setModalOpenState(false);
  };

  const showInlineNotice = (widget, html, type = 'success') => {
    const root = widget?.querySelector('.judgeme-pdp-root');
    if (!root) return;

    const oldNotice = root.querySelector('.judgeme-pdp-inline-notice');
    if (oldNotice) oldNotice.remove();

    const notice = createElement('div', 'judgeme-pdp-inline-notice');
    notice.classList.toggle('is-error', type === 'error');
    notice.innerHTML = html;

    const cta = root.querySelector('.judgeme-pdp-cta');
    if (cta) {
      cta.before(notice);
    } else {
      root.appendChild(notice);
    }

    setTimeout(() => {
      notice.remove();
    }, 8000);
  };

  const getSubmitEndpoint = () => {
    if (window.jdgm?.followUpToken) {
      return 'https://api.judge.me/reviews/update_review';
    }

    const host = String(window.jdgm?.API_HOST || 'https://api.judge.me').replace(/\/$/, '');
    return `${host}/api/v1/reviews`;
  };

  const buildSubmitFormData = (widget, values) => {
    const params = new FormData();
    const query = new URLSearchParams(window.location.search);
    const productId = getProductId(widget);
    const shopParams =
      typeof window.jdgm?.shopParams === 'function'
        ? window.jdgm.shopParams()
        : {
            url: getShopDomain(),
            shop_domain: getShopDomain(),
            platform: window.jdgmSettings?.platform || 'shopify',
          };

    const appendIfDefined = (key, value) => {
      if (value == null) return;
      const normalized = normalizeString(value);
      if (!normalized) return;
      params.append(key, normalized);
    };

    Object.entries(shopParams).forEach(([key, value]) => {
      appendIfDefined(key, value);
    });

    appendIfDefined(
      'reviewer_name_format',
      window.jdgmSettings?.widget_reviewer_name_as_initial || ''
    );
    appendIfDefined('name', values.name);
    appendIfDefined('email', values.email);
    appendIfDefined('rating', String(values.rating));
    appendIfDefined('title', values.title);
    appendIfDefined('body', values.body);
    appendIfDefined('id', productId);
    appendIfDefined('review_token', window.jdgm?.followUpToken || '');
    appendIfDefined('token', query.get('judgeme_token'));
    appendIfDefined('judgeme_review_source', query.get('judgeme_review_source'));
    appendIfDefined('judgeme_upload_pictures', query.get('judgeme_upload_pictures'));
    appendIfDefined(
      'template_locale',
      query.get('template_locale') || window.jdgmSettings?.shop_locale || ''
    );

    return params;
  };

  const submitWriteReview = async (widget, values) => {
    const response = await fetch(getSubmitEndpoint(), {
      method: 'POST',
      body: buildSubmitFormData(widget, values),
      credentials: 'omit',
    });

    if (!response.ok) {
      throw new Error(`Judge.me review submit failed with status ${response.status}`);
    }
  };

  const validateModalValues = (values) => {
    const i18n = getI18n();
    const requiredFieldError =
      window.jdgmSettings?.widget_required_field_error_text || i18n.modalRequiredRating;
    const invalidEmailError =
      window.jdgmSettings?.widget_email_field_error_text || i18n.modalInvalidEmail;

    if (!values.rating || values.rating < 1) {
      return i18n.modalRequiredRating || requiredFieldError;
    }

    if (!values.name || !values.email) {
      return requiredFieldError;
    }

    if (!EMAIL_PATTERN.test(values.email)) {
      return invalidEmailError;
    }

    const ratingOnly = Boolean(window.jdgmSettings?.rating_only_reviews_enabled);
    if (!ratingOnly && !values.body) {
      return requiredFieldError;
    }

    return '';
  };

  const openWriteReviewModal = (widget) => {
    const productId = getProductId(widget);
    if (!productId && !isStoreReviewsWidget(widget)) return;

    closeWriteReviewModal();

    const i18n = getI18n();
    const settings = window.jdgmSettings || {};
    const publicName = normalizeString(settings.default_reviewer_name) || 'John Smith';
    const displayNameLabel = fillTemplate(i18n.modalDisplayNameLabel, 'public_name', publicName);
    const gdprHtml = decodeHtmlString(
      i18n.modalGdpr || window.jdgmSettings?.widget_gdpr_statement || ''
    );

    const modal = createElement('div', 'judgeme-pdp-modal');
    modal.id = MODAL_ID;
    modal.innerHTML = `
      <div class="judgeme-pdp-modal__backdrop" data-modal-close></div>
      <div class="judgeme-pdp-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="judgeme-pdp-modal-title" data-lenis-prevent data-lenis-prevent-touch>
        <form class="judgeme-pdp-modal__form" novalidate>
          <header class="judgeme-pdp-modal__header">
            <h3 class="judgeme-pdp-modal__title" id="judgeme-pdp-modal-title">${escapeHtml(i18n.modalTitle)}</h3>
            <button class="judgeme-pdp-modal__close" type="button" aria-label="${escapeHtml(i18n.modalClose)}">×</button>
          </header>

          <div class="judgeme-pdp-modal__top-fields">
            <label class="judgeme-pdp-modal__field judgeme-pdp-modal__field--title">
              <span class="judgeme-pdp-modal__label">${escapeHtml(i18n.modalReviewTitleLabel)}</span>
              <input
                class="judgeme-pdp-modal__input"
                type="text"
                name="review_title"
                maxlength="100"
                placeholder="${escapeHtml(i18n.modalReviewTitlePlaceholder)}"
              >
            </label>

            <fieldset class="judgeme-pdp-modal__rating-field">
              <legend class="judgeme-pdp-modal__label">${escapeHtml(i18n.modalRatingLabel)}</legend>
              <div class="judgeme-pdp-modal__rating-dots" role="radiogroup" aria-label="${escapeHtml(i18n.modalRatingLabel)}">
                <button type="button" class="judgeme-pdp-modal__rating-dot is-filled" data-rating-value="1" aria-label="1 / 5"></button>
                <button type="button" class="judgeme-pdp-modal__rating-dot" data-rating-value="2" aria-label="2 / 5"></button>
                <button type="button" class="judgeme-pdp-modal__rating-dot" data-rating-value="3" aria-label="3 / 5"></button>
                <button type="button" class="judgeme-pdp-modal__rating-dot" data-rating-value="4" aria-label="4 / 5"></button>
                <button type="button" class="judgeme-pdp-modal__rating-dot" data-rating-value="5" aria-label="5 / 5"></button>
              </div>
            </fieldset>
          </div>

          <label class="judgeme-pdp-modal__field judgeme-pdp-modal__field--body">
            <span class="judgeme-pdp-modal__label">${escapeHtml(i18n.modalBodyLabel)}</span>
            <textarea
              class="judgeme-pdp-modal__textarea"
              name="review_body"
              rows="4"
              maxlength="5000"
              placeholder="${escapeHtml(i18n.modalBodyPlaceholder)}"
            ></textarea>
          </label>

          <label class="judgeme-pdp-modal__field">
            <span class="judgeme-pdp-modal__label">${escapeHtml(displayNameLabel)}</span>
            <input
              class="judgeme-pdp-modal__input"
              type="text"
              name="reviewer_name"
              maxlength="100"
              placeholder="${escapeHtml(i18n.modalDisplayNamePlaceholder)}"
              required
            >
          </label>

          <label class="judgeme-pdp-modal__field">
            <span class="judgeme-pdp-modal__label">${escapeHtml(i18n.modalEmailLabel)}</span>
            <input
              class="judgeme-pdp-modal__input"
              type="email"
              name="reviewer_email"
              placeholder="${escapeHtml(i18n.modalEmailPlaceholder)}"
              required
            >
          </label>

          <p class="judgeme-pdp-modal__gdpr">${gdprHtml}</p>
          <p class="judgeme-pdp-modal__status" aria-live="polite"></p>

          <button class="judgeme-pdp-modal__submit" type="submit">
            <span class="judgeme-pdp-modal__submit-lead">${escapeHtml(i18n.modalSubmitLead)}</span>
            <span class="judgeme-pdp-modal__submit-right">
              <span class="judgeme-pdp-modal__submit-divider"></span>
              <span class="judgeme-pdp-modal__submit-label">${escapeHtml(i18n.modalSubmitAction)}</span>
              <span class="judgeme-pdp-modal__submit-arrow" aria-hidden="true">→</span>
            </span>
          </button>
        </form>
      </div>
    `;

    document.body.appendChild(modal);
    setModalOpenState(true);

    const closeButton = modal.querySelector('.judgeme-pdp-modal__close');
    const dialog = modal.querySelector('.judgeme-pdp-modal__dialog');
    const form = modal.querySelector('.judgeme-pdp-modal__form');
    const status = modal.querySelector('.judgeme-pdp-modal__status');
    const ratingButtons = Array.from(
      modal.querySelectorAll('.judgeme-pdp-modal__rating-dot[data-rating-value]')
    );
    const submitButton = modal.querySelector('.judgeme-pdp-modal__submit');
    const submitLabel = modal.querySelector('.judgeme-pdp-modal__submit-label');

    let selectedRating = 1;
    let isSubmitting = false;

    const keepFocusedFieldVisible = () => {
      const focusedField = document.activeElement;
      if (!dialog || !focusedField || !form?.contains(focusedField)) return;

      const viewport = window.visualViewport;
      const viewportTop = viewport?.offsetTop || 0;
      const viewportBottom = viewportTop + (viewport?.height || window.innerHeight);
      const fieldRect = focusedField.getBoundingClientRect();
      const topGutter = 24;
      const bottomGutter = 32;

      if (fieldRect.bottom > viewportBottom - bottomGutter) {
        dialog.scrollTop += fieldRect.bottom - viewportBottom + bottomGutter;
      } else if (fieldRect.top < viewportTop + topGutter) {
        dialog.scrollTop -= viewportTop + topGutter - fieldRect.top;
      }
    };

    const updateModalViewport = () => {
      const viewport = window.visualViewport;
      const viewportHeight = viewport?.height || window.innerHeight;
      const viewportTop = viewport?.offsetTop || 0;

      modal.style.setProperty('--judgeme-modal-viewport-height', `${viewportHeight}px`);
      modal.style.setProperty('--judgeme-modal-viewport-top', `${viewportTop}px`);

      window.cancelAnimationFrame(modal.__focusVisibilityFrame || 0);
      modal.__focusVisibilityFrame = window.requestAnimationFrame(keepFocusedFieldVisible);
      window.clearTimeout(modal.__focusVisibilityTimeout);
      modal.__focusVisibilityTimeout = window.setTimeout(keepFocusedFieldVisible, 250);
    };

    modal.__onVisualViewportChange = updateModalViewport;
    updateModalViewport();
    window.visualViewport?.addEventListener('resize', updateModalViewport, { passive: true });
    window.visualViewport?.addEventListener('scroll', updateModalViewport, { passive: true });
    window.addEventListener('resize', updateModalViewport, { passive: true });
    form?.addEventListener('focusin', updateModalViewport);

    const setRating = (value) => {
      selectedRating = Math.max(1, Math.min(5, Number(value) || 1));

      ratingButtons.forEach((node, index) => {
        node.classList.toggle('is-filled', index < selectedRating);
      });
    };

    const setStatus = (message, asError = false) => {
      if (!status) return;
      status.classList.toggle('is-error', asError);
      if (asError) {
        status.textContent = message;
      } else {
        status.innerHTML = message;
      }
    };

    const setSubmitting = (nextValue) => {
      isSubmitting = nextValue;
      submitButton?.toggleAttribute('disabled', nextValue);
      modal.classList.toggle('is-submitting', nextValue);
      if (submitLabel) {
        submitLabel.textContent = nextValue
          ? i18n.modalSubmittingAction
          : i18n.modalSubmitAction;
      }
    };

    const onEscape = (event) => {
      if (event.key !== 'Escape') return;
      closeWriteReviewModal();
    };

    modal.__onEscape = onEscape;
    document.addEventListener('keydown', onEscape);

    closeButton?.addEventListener('click', () => {
      closeWriteReviewModal();
    });

    modal.addEventListener('click', (event) => {
      if (dialog?.contains(event.target)) return;
      closeWriteReviewModal();
    });

    ratingButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setRating(Number(button.dataset.ratingValue));
      });
    });

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (isSubmitting) return;

      const nameInput = form.querySelector('input[name="reviewer_name"]');
      const emailInput = form.querySelector('input[name="reviewer_email"]');
      const titleInput = form.querySelector('input[name="review_title"]');
      const bodyInput = form.querySelector('textarea[name="review_body"]');

      const values = {
        name: normalizeString(nameInput?.value || ''),
        email: normalizeString(emailInput?.value || ''),
        title: normalizeString(titleInput?.value || ''),
        body: normalizeString(bodyInput?.value || ''),
        rating: selectedRating,
      };

      const validationError = validateModalValues(values);
      if (validationError) {
        setStatus(validationError, true);
        return;
      }

      setStatus('');
      setSubmitting(true);

      try {
        await submitWriteReview(widget, values);

        const successHtml =
          getSubmitSuccessHtml() || escapeHtml(stripHtml(window.jdgmSettings?.widget_submit_review_text));
        showInlineNotice(widget, successHtml, 'success');

        const state = stateByWidget.get(widget);
        if (state) {
          state.loadedSorts = new Set();
          state.currentPage = 1;
          stateByWidget.set(widget, state);
        }

        closeWriteReviewModal();
        await loadReviews(widget, { forceRefresh: true });
      } catch (error) {
        console.error('Failed to submit Judge.me review', error);
        setStatus(i18n.modalSubmitError, true);
      } finally {
        setSubmitting(false);
      }
    });
  };

  const sortParamsFor = (sortKey) => {
    if (sortKey === 'highest_rating') {
      return { sortBy: 'rating', sortDir: 'desc' };
    }

    if (sortKey === 'lowest_rating') {
      return { sortBy: 'rating', sortDir: 'asc' };
    }

    return { sortBy: 'created_at', sortDir: 'desc' };
  };

  const normalizeReview = (review, index) => {
    const name = getReviewerName(review, index);
    const rating = clampRating(review?.rating);

    return {
      uuid: normalizeString(review?.uuid) || `${name}-${index}`,
      name,
      rating,
      title: getReviewTitle(review),
      body: getReviewBody(review),
      verified: Boolean(review?.verified_buyer || review?.verified),
      createdAt: normalizeString(review?.created_at || review?.date),
    };
  };

  const getInitialData = (widget) => {
    if (isStoreReviewsWidget(widget)) {
      const raw = window.jdgm?.data?.allReviewsWidgetV2025;
      if (!raw || typeof raw !== 'object') return null;

      const reviews = Array.isArray(raw.shop_reviews)
        ? raw.shop_reviews.map((review, index) => normalizeReview(review, index))
        : [];
      const averageRating =
        reviews.reduce((sum, review) => sum + review.rating, 0) / (reviews.length || 1);

      return {
        reviews,
        numberOfReviews: Number(raw.number_of_shop_reviews) || reviews.length,
        averageRating,
      };
    }

    const productId = getProductId(widget);
    if (!productId) return null;

    const raw = window.jdgm?.data?.reviewWidget?.[productId];
    if (!raw || typeof raw !== 'object') return null;

    const reviews = Array.isArray(raw.reviews)
      ? raw.reviews.map((review, index) => normalizeReview(review, index))
      : [];

    return {
      reviews,
      numberOfReviews: Number(raw.number_of_reviews) || reviews.length,
      averageRating: Number(raw.average_rating) || null,
    };
  };

  const dedupeReviews = (reviews) => {
    const map = new Map();

    reviews.forEach((review, index) => {
      const key = normalizeString(review.uuid) || `${review.name}-${index}`;
      if (!map.has(key)) {
        map.set(key, review);
      }
    });

    return Array.from(map.values());
  };

  const parseStoreReviewsHtml = (html) => {
    const container = document.createElement('div');
    container.innerHTML = String(html || '');

    return Array.from(container.querySelectorAll('.jdgm-rev')).map((reviewNode, index) => ({
      uuid: normalizeString(reviewNode.dataset.reviewId) || `store-review-${index}`,
      reviewer_name:
        normalizeString(reviewNode.querySelector('.jdgm-rev__author')?.textContent) ||
        getI18n().reviewerFallback,
      rating: Number(reviewNode.querySelector('.jdgm-rev__rating')?.dataset.score) || 0,
      title: normalizeString(reviewNode.querySelector('.jdgm-rev__title')?.textContent),
      body: normalizeString(reviewNode.querySelector('.jdgm-rev__body')?.textContent),
      verified_buyer: reviewNode.dataset.verifiedBuyer === 'true',
      created_at: normalizeString(
        reviewNode.querySelector('.jdgm-rev__timestamp')?.dataset.content
      ),
    }));
  };

  const fetchReviewsPage = async (widget, page, sortKey) => {
    const productId = getProductId(widget);
    const storeReviews = isStoreReviewsWidget(widget);
    if (!productId && !storeReviews) return null;

    const params = new URLSearchParams({
      shop_domain: getShopDomain(),
      platform: window.jdgmSettings?.platform || 'shopify',
      page: String(page),
      per_page: '100',
    });

    if (storeReviews) {
      params.set('review_type', 'shop-reviews');
    } else {
      params.set('product_id', String(productId));
    }

    const sortParams = sortParamsFor(sortKey);
    if (sortParams.sortBy) params.set('sort_by', sortParams.sortBy);
    if (sortParams.sortDir) params.set('sort_dir', sortParams.sortDir);

    const endpoint = storeReviews
      ? 'https://cdn.judge.me/reviews/all_reviews_js_based'
      : 'https://api.judge.me/reviews/reviews_for_widget';
    const response = await fetch(
      `${endpoint}?${params.toString()}`,
      {
        method: 'GET',
        credentials: 'omit',
        headers: {
          Accept: 'application/json',
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Judge.me reviews request failed with status ${response.status}`);
    }

    const payload = await response.json();
    if (!storeReviews) return payload;

    const reviews = parseStoreReviewsHtml(payload.html);
    const storeData = window.jdgm?.data?.allReviewsWidgetV2025 || {};
    const numberOfReviews =
      Number(payload.number_of_shop_reviews) ||
      Number(storeData.number_of_shop_reviews) ||
      reviews.length;

    return {
      reviews,
      number_of_reviews: numberOfReviews,
      pagination: {
        total_pages: Math.max(1, Math.ceil(numberOfReviews / 100)),
      },
    };
  };

  const fetchAllReviewsForSort = async (widget, sortKey) => {
    const firstPage = await fetchReviewsPage(widget, 1, sortKey);
    if (!firstPage) return null;

    const firstPageReviews = Array.isArray(firstPage.reviews) ? firstPage.reviews : [];
    const totalFromApi = Number(firstPage.number_of_reviews);
    const explicitTotalPages =
      Number(firstPage?.pagination?.total_pages) ||
      Number(firstPage?.pagination?.pages_count) ||
      Number(firstPage?.pagination?.totalPages) ||
      Number(firstPage?.total_pages);
    const inferredPageSize = Math.max(1, firstPageReviews.length || 1);
    const inferredTotalPages =
      Number.isFinite(totalFromApi) && totalFromApi > 0
        ? Math.ceil(totalFromApi / inferredPageSize)
        : 1;
    const totalPages = Math.max(1, explicitTotalPages || inferredTotalPages);

    const requests = [];
    for (let page = 2; page <= totalPages; page += 1) {
      requests.push(fetchReviewsPage(widget, page, sortKey));
    }

    const restPages = requests.length ? await Promise.all(requests) : [];

    const allRawReviews = [...firstPageReviews];
    restPages.forEach((pageResult) => {
      if (Array.isArray(pageResult?.reviews)) {
        allRawReviews.push(...pageResult.reviews);
      }
    });

    const normalizedReviews = dedupeReviews(
      allRawReviews.map((review, index) => normalizeReview(review, index))
    );

    const averageFromApi = Number(firstPage.average_rating);
    const averageRating = Number.isFinite(averageFromApi)
      ? averageFromApi
      : normalizedReviews.reduce((sum, review) => sum + review.rating, 0) /
        (normalizedReviews.length || 1);

    return {
      reviews: normalizedReviews,
      numberOfReviews:
        Number.isFinite(totalFromApi) && totalFromApi > 0
          ? totalFromApi
          : normalizedReviews.length,
      averageRating,
    };
  };

  const getVerifiedLabel = () => {
    const settings = window.jdgmSettings || {};
    return (
      settings.verified_badge_text ||
      settings.widget_verified_text ||
      settings.widget_verified_by_shop_text ||
      'Verified'
    );
  };

  const buildReviewRow = (
    review,
    index = 0,
    showVerified = true,
    isStoreReview = false
  ) => {
    const row = createElement('article', 'judgeme-pdp-review');
    row.style.setProperty('--stagger-index', String(index));
    if (isStoreReview) {
      row.classList.add('judgeme-pdp-review--store');
    }

    const left = createElement('div', 'judgeme-pdp-review__left');
    left.appendChild(createRatingDots(review.rating));

    const right = createElement('div', 'judgeme-pdp-review__right');

    const header = createElement('div', 'judgeme-pdp-review__header');

    if (showVerified && review.verified) {
      const badge = createElement('span', 'judgeme-pdp-review__badge', getVerifiedLabel());
      header.appendChild(badge);
    }

    header.appendChild(createElement('h4', 'judgeme-pdp-review__author', review.name));

    const formattedDate = formatReviewDate(review.createdAt);
    let date = null;
    if (formattedDate) {
      date = createElement('time', 'judgeme-pdp-review__date', formattedDate.label);
      date.dateTime = formattedDate.dateTime;
    }

    if (isStoreReview && date) {
      header.appendChild(date);
    }

    right.appendChild(header);

    const title = review.title;
    if (title) {
      right.appendChild(createElement('h5', 'judgeme-pdp-review__title', title));
    }

    if (review.body) {
      right.appendChild(createElement('p', 'judgeme-pdp-review__body', review.body));
    }

    if (!isStoreReview && date) right.appendChild(date);

    row.append(left, right);
    return row;
  };

  const buildRoot = (widget, state) => {
    const i18n = getI18n();
    const sortLabels = getSortLabels();
    const productTitle = getProductTitle(widget);

    const reviews = Array.isArray(state.reviews) ? state.reviews : [];
    const totalReviews = Number(state.numberOfReviews) || reviews.length;
    const hasReviews = reviews.length > 0;

    const totalPages = Math.max(1, Math.ceil(reviews.length / REVIEWS_PER_PAGE));
    state.currentPage = Math.min(totalPages, Math.max(1, Number(state.currentPage) || 1));

    const start = (state.currentPage - 1) * REVIEWS_PER_PAGE;
    const end = start + REVIEWS_PER_PAGE;
    const visibleReviews = reviews.slice(start, end);

    const root = createElement('div', 'judgeme-pdp-root');

    const summary = createElement('section', 'judgeme-pdp-summary');

    const topLine = createElement('div', 'judgeme-pdp-summary__topline');
    summary.appendChild(topLine);

    const summaryMain = createElement('div', 'judgeme-pdp-summary__main');
    const summaryLeft = createElement('div', 'judgeme-pdp-summary__left');

    const heading = createElement('h2', 'judgeme-pdp-summary__title', productTitle);
    summaryLeft.appendChild(heading);

    const meta = createElement('div', 'judgeme-pdp-summary__meta');
    meta.appendChild(createRatingDots(Number(state.averageRating) || 0));
    meta.appendChild(createElement('p', 'judgeme-pdp-summary__count', getReviewCountLabel(totalReviews)));
    summaryLeft.appendChild(meta);

    summaryMain.appendChild(summaryLeft);

    if (hasReviews) {
      const sortField = createElement('div', 'judgeme-pdp-sort-field');
      if (state.isSortOpen) {
        sortField.classList.add('is-open');
      }
      const sortSelect = createElement('select', 'judgeme-pdp-sort-field__select');
      sortSelect.id = `judgeme-sort-${state.id}`;

      SORT_OPTIONS.forEach((optionValue) => {
        const option = createElement('option', '', sortLabels[optionValue] || optionValue);
        option.value = optionValue;
        if (optionValue === state.sortKey) option.selected = true;
        sortSelect.appendChild(option);
      });

      sortSelect.value = state.sortKey;

      const sortTrigger = createElement('button', 'judgeme-pdp-sort-trigger');
      sortTrigger.type = 'button';
      sortTrigger.setAttribute('aria-expanded', state.isSortOpen ? 'true' : 'false');
      sortTrigger.setAttribute('aria-controls', `judgeme-sort-panel-${state.id}`);

      const sortTriggerValue = createElement('span', 'judgeme-pdp-sort-trigger__value');
      sortTriggerValue.appendChild(createElement('span', 'judgeme-pdp-sort-prefix', i18n.sortLabel));
      sortTriggerValue.appendChild(
        createElement('span', 'judgeme-pdp-sort-trigger__current', sortLabels[state.sortKey] || '')
      );

      const sortArrow = createElement('span', 'judgeme-pdp-sort-trigger__caret');
      sortArrow.setAttribute('aria-hidden', 'true');

      sortTrigger.append(sortTriggerValue, sortArrow);

      sortTrigger.addEventListener('click', () => {
        state.isSortOpen = !state.isSortOpen;
        stateByWidget.set(widget, state);
        render(widget);
      });

      sortTrigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        state.isSortOpen = false;
        stateByWidget.set(widget, state);
        render(widget);
      });

      const sortPanel = createElement('div', 'judgeme-pdp-sort-panel');
      sortPanel.id = `judgeme-sort-panel-${state.id}`;
      if (!state.isSortOpen) {
        sortPanel.hidden = true;
      }

      SORT_OPTIONS.forEach((optionValue) => {
        const optionButton = createElement(
          'button',
          `judgeme-pdp-sort-option${optionValue === state.sortKey ? ' is-active' : ''}`,
          sortLabels[optionValue] || optionValue
        );
        optionButton.type = 'button';
        optionButton.addEventListener('click', () => {
          state.isSortOpen = false;
          if (optionValue === state.sortKey) {
            stateByWidget.set(widget, state);
            render(widget);
            return;
          }

          state.sortKey = optionValue;
          state.currentPage = 1;
          stateByWidget.set(widget, state);
          render(widget);
          loadReviews(widget, { forceRefresh: true });
        });

        sortPanel.appendChild(optionButton);
      });

      sortField.append(sortSelect, sortTrigger, sortPanel);
      summaryMain.appendChild(sortField);
    }

    summary.append(summaryMain);

    if (hasReviews) {
      const contentDivider = createElement('div', 'judgeme-pdp-content-divider');
      root.appendChild(contentDivider);

      const shell = createElement('div', 'judgeme-pdp-shell');

      const sidebar = createElement('aside', 'judgeme-pdp-sidebar');

      if (reviews.length > REVIEWS_PER_PAGE) {
        const pager = createElement('nav', 'judgeme-pdp-pager');
        pager.setAttribute('aria-label', i18n.paginationLabel);
        const arrowAssets = widget.closest('[data-judgeme-arrow-prev-src]')?.dataset;

        const addPage = (pages, page) => {
          const pageLabel = String(page).padStart(2, '0');
          const pageButton = createElement(
            'button',
            `judgeme-pdp-pages__page${page === state.currentPage ? ' is-active' : ''}`,
            pageLabel
          );
          pageButton.type = 'button';
          pageButton.setAttribute('aria-label', i18n.paginationPage.replace('__number__', pageLabel));

          if (page === state.currentPage) {
            pageButton.setAttribute('aria-current', 'page');
          }

          pageButton.addEventListener('click', () => {
            if (page === state.currentPage) return;
            state.pendingTransition = page < state.currentPage ? 'prev' : 'next';
            state.currentPage = page;
            stateByWidget.set(widget, state);
            render(widget);
          });

          pages.appendChild(pageButton);
        };

        const prev = createElement(
          'button',
          'judgeme-pdp-pager__btn judgeme-pdp-pager__btn--prev'
        );
        prev.type = 'button';
        prev.disabled = state.currentPage <= 1;
        prev.setAttribute('aria-label', i18n.paginationPrevious);
        const prevIcon = createElement('img', 'judgeme-pdp-pager__icon');
        prevIcon.src = arrowAssets?.judgemeArrowPrevSrc || '';
        prevIcon.alt = '';
        prev.appendChild(prevIcon);
        prev.addEventListener('click', () => {
          if (state.currentPage <= 1) return;
          state.pendingTransition = 'prev';
          state.currentPage -= 1;
          stateByWidget.set(widget, state);
          render(widget);
        });

        const pages = createElement('div', 'judgeme-pdp-pages');
        addPage(pages, state.currentPage === totalPages ? 1 : state.currentPage);

        if (totalPages > 2) {
          const dots = createElement('span', 'judgeme-pdp-pages__dots');
          dots.setAttribute('aria-hidden', 'true');
          dots.append(createElement('span'), createElement('span'), createElement('span'));
          pages.appendChild(dots);
        }

        addPage(pages, totalPages);

        const next = createElement(
          'button',
          'judgeme-pdp-pager__btn judgeme-pdp-pager__btn--next'
        );
        next.type = 'button';
        next.disabled = state.currentPage >= totalPages;
        next.setAttribute('aria-label', i18n.paginationNext);
        const nextIcon = createElement('img', 'judgeme-pdp-pager__icon');
        nextIcon.src = arrowAssets?.judgemeArrowNextSrc || '';
        nextIcon.alt = '';
        next.appendChild(nextIcon);
        next.addEventListener('click', () => {
          if (state.currentPage >= totalPages) return;
          state.pendingTransition = 'next';
          state.currentPage += 1;
          stateByWidget.set(widget, state);
          render(widget);
        });

        pager.append(prev, pages, next);
        sidebar.appendChild(pager);
      }

      const reviewsColumn = createElement('div', 'judgeme-pdp-reviews');
      const storeReviews = isStoreReviewsWidget(widget);

      visibleReviews.forEach((review, index) => {
        reviewsColumn.appendChild(buildReviewRow(review, index, !storeReviews, storeReviews));
      });

      const reviewsStage = createElement('div', 'judgeme-pdp-stage judgeme-pdp-stage--reviews');
      const reviewsViewport = createElement('div', 'judgeme-pdp-stage__viewport');
      reviewsViewport.appendChild(reviewsColumn);
      reviewsStage.appendChild(reviewsViewport);

      shell.append(sidebar, reviewsStage);
      root.appendChild(shell);
    } else {
      root.appendChild(createElement('p', 'judgeme-pdp-empty', i18n.noReviewsText));
    }

    const cta = createElement('div', 'judgeme-pdp-cta');
    cta.appendChild(createElement('span', 'judgeme-pdp-cta__lead', i18n.ctaLead));

    const action = createElement('button', 'judgeme-pdp-cta__action');
    action.type = 'button';
    action.addEventListener('click', () => {
      openWriteReviewModal(widget);
    });

    action.appendChild(createElement('span', 'judgeme-pdp-cta__divider'));
    action.appendChild(createElement('span', 'judgeme-pdp-cta__label', i18n.writeReview));
    action.appendChild(createElement('span', 'judgeme-pdp-cta__arrow', '→'));

    cta.appendChild(action);

    root.prepend(summary);
    root.appendChild(cta);

    if (state.isLoading) {
      root.classList.add('is-loading');
    }

    return root;
  };

  const createInitialState = (widget) => {
    const data = getInitialData(widget);
    const id = getProductId(widget) || Math.random().toString(16).slice(2);

    return {
      id,
      sortKey: 'created_at',
      currentPage: 1,
      isLoading: false,
      reviews: data?.reviews || [],
      numberOfReviews: data?.numberOfReviews || 0,
      averageRating: data?.averageRating || 0,
      loadedSorts: new Set(),
      pendingTransition: null,
      maxReviewsHeight: 0,
      isSortOpen: false,
    };
  };

  const render = (widget) => {
    if (!widget) return;

    let state = stateByWidget.get(widget);
    if (!state) {
      state = createInitialState(widget);
      stateByWidget.set(widget, state);
    }

    ensureKicker(widget);

    widget.classList.add('judgeme-pdp-widget', 'judgeme-pdp-has-custom');

    const oldRoot = widget.querySelector('.judgeme-pdp-root');
    const previousReviews =
      state.pendingTransition && oldRoot
        ? oldRoot.querySelector('.judgeme-pdp-reviews')?.cloneNode(true)
        : null;
    const previousReviewsHeight = getBoxHeight(oldRoot, '.judgeme-pdp-reviews');
    const newRoot = buildRoot(widget, state);

    if (oldRoot) {
      oldRoot.replaceWith(newRoot);
    } else {
      widget.prepend(newRoot);
    }

    const reviewsConfig = {
      stageSelector: '.judgeme-pdp-stage--reviews',
      contentSelector: '.judgeme-pdp-reviews',
      stateKey: 'maxReviewsHeight',
      stageClass: 'is-reviews-transition',
    };

    if (state.pendingTransition && previousReviews) {
      animateStageTransition(
        newRoot,
        previousReviews,
        state.pendingTransition,
        state,
        reviewsConfig,
        previousReviewsHeight
      );
    } else {
      syncStageHeight(newRoot, state, reviewsConfig, previousReviewsHeight);
    }

    state.pendingTransition = null;
    stateByWidget.set(widget, state);
  };

  const setLoading = (widget, loading) => {
    const state = stateByWidget.get(widget);
    if (!state) return;

    state.isLoading = loading;
    stateByWidget.set(widget, state);

    const root = widget.querySelector('.judgeme-pdp-root');
    if (root) {
      root.classList.toggle('is-loading', loading);
    }
  };

  const loadReviews = async (widget, { forceRefresh = false, silent = false } = {}) => {
    const state = stateByWidget.get(widget) || createInitialState(widget);
    stateByWidget.set(widget, state);

    const hasSortLoaded = state.loadedSorts instanceof Set && state.loadedSorts.has(state.sortKey);

    if (!forceRefresh && hasSortLoaded) return;

    if (!silent) setLoading(widget, true);

    try {
      const fetched = await fetchAllReviewsForSort(widget, state.sortKey);
      if (!fetched) return;

      state.reviews = fetched.reviews;
      state.numberOfReviews = fetched.numberOfReviews;
      state.averageRating = fetched.averageRating;
      state.loadedSorts.add(state.sortKey);
      state.currentPage = 1;
      stateByWidget.set(widget, state);
      render(widget);
    } catch (error) {
      console.error('Failed to load Judge.me reviews', error);
    } finally {
      if (!silent) setLoading(widget, false);
    }
  };

  const patchWidget = (widget) => {
    if (!widget) return;

    if (widget.dataset.perfumiarzJudgeMePatched === 'loading') return;

    if (widget.dataset.perfumiarzJudgeMePatched === 'true') {
      if (!widget.querySelector('.judgeme-pdp-root')) {
        render(widget);
      }
      return;
    }

    widget.dataset.perfumiarzJudgeMePatched = 'loading';

    if (isStoreReviewsWidget(widget)) {
      render(widget);
    }

    loadReviews(widget, { silent: true })
      .catch((error) => {
        console.error('Failed to initialize Judge.me reviews layout', error);
      })
      .finally(() => {
        if (!widget.querySelector('.judgeme-pdp-root')) render(widget);
        widget.dataset.perfumiarzJudgeMePatched = 'true';
      });
  };

  const update = () => {
    if (isUpdating) return;

    isUpdating = true;
    try {
      document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
        patchWidget(widget);
      });
    } finally {
      requestAnimationFrame(() => {
        isUpdating = false;
      });
    }
  };

  const scheduleUpdate = () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      update();
      rafId = null;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpdate);
  } else {
    scheduleUpdate();
  }

  const observer = new MutationObserver(scheduleUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('shopify:section:load', scheduleUpdate);
})();
